'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('teacherCourses', {
                parent: 'entity',
                url: '/teacherCourses',
                data: {
                    roles: ['OP_VIEW_TEACHER_COURSES'],
                    pageTitle: 'lmsApp.teacherCourses.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/teacherCourses/teacherCourses.html',
                        controller: 'teacherCoursesController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('teacherCourses');
                        return $translate.refresh();
                    }]
                }
            })
            .state('teacherCoursesDetail', {
                parent: 'entity',
                url: '/teacherCourses/:id',
                data: {
                    roles: ['OP_VIEW_TEACHER_COURSES'],
                    pageTitle: 'lmsApp.teacherCourses.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/teacherCourses/teacherCourses-detail.html',
                        controller: 'teacherCoursesDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('teacherCourses');
                        return $translate.refresh();
                    }]
                }
            })
            .state('teacherCoursesRedact', {
                parent: 'entity',
                url: '/teacherCourses/:id/redact',
                data: {
                    roles: ['OP_MANAGE_TEACHER_COURSES'],
                    pageTitle: 'lmsApp.teacherCourses.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/teacherCourses/teacherCourses-redact.html',
                        controller: 'teacherCoursesRedactController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('teacherCourses');
                        return $translate.refresh();
                    }]
                }
            });
    });
